<div class="page">
  <!-- Main Header-->
  <div class="main-header side-header sticky">
    <div class="main-container container-fluid">
      <div class="main-header-left">
        <a class="main-header-menu-icon" href="javascript:void(0)" id="mainSidebarToggle"><span></span></a>
        <div class="hor-logo">
          <a class="main-logo" href="index.html">
            <img src="../../assets/images/logo-light.png" class="header-brand-img desktop-logo" alt="logo">
            <img src="../../assets/images/logo-light.png" class="header-brand-img desktop-logo-dark " alt="logo">
          </a>
        </div>
      </div>
      <div class="main-header-center">
        <div class="responsive-logo">
          <a href="#"><img src="../../assets/images/logo-light.png" class="mobile-logo" alt="logo"></a>
          <a href="#"><img src="../../assets/images/logo-light.png" class="mobile-logo-dark" alt="logo"></a>
        </div>
        <div class="input-group">
          <!-- <div class="input-group-btn search-panel">
            <select class="form-control select2">
              <option label="All categories">
              </option>
              <option value="Students Record">
                Students Record
              </option>
              <option value="Staff Records">
                Staff Records
              </option>
              <option value="Teachers Record">
                Teachers Record
              </option>
            </select>
          </div>
          <input type="search" class="form-control rounded-0" placeholder="Search for anything...">
          <button class="btn search-btn"><i class="fe fe-search"></i></button> -->
          <div class="session-div">
            <h6 class="session-h">{{SessionStatus}} - {{sessionName}}</h6>
          </div>
        </div>
      </div>
      <div class="main-header-right">
        <button class="navbar-toggler navresponsive-toggler" type="button" data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent-4" aria-controls="navbarSupportedContent-4" aria-expanded="false"
          aria-label="Toggle navigation">
          <i class="fe fe-more-vertical header-icons navbar-toggler-icon"></i>
        </button><!-- Navresponsive closed -->
        <div class="navbar navbar-expand-lg  nav nav-item  navbar-nav-right responsive-navbar navbar-dark  ">
          <div class="collapse navbar-collapse" id="navbarSupportedContent-4">
            <div class="d-flex order-lg-2 ms-auto">
              <!-- Search -->
              <div class="dropdown header-search">
                <a class="nav-link icon header-search">
                  <i class="fe fe-search header-icons"></i>
                </a>
                <div class="dropdown-menu">
                  <div class="main-form-search p-2">
                    <div class="input-group">
                      <div class="input-group-btn search-panel">
                        <select class="form-control select2">
                          <option label="All categories">
                          </option>
                          <option value="IT Projects">
                            IT Projects
                          </option>
                          <option value="Business Case">
                            Business Case
                          </option>
                          <option value="Microsoft Project">
                            Microsoft Project
                          </option>
                          <option value="Risk Management">
                            Risk Management
                          </option>
                          <option value="Team Building">
                            Team Building
                          </option>
                        </select>
                      </div>
                      <input type="search" class="form-control " placeholder="Search for anything...">
                      <button class="btn search-btn"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                          viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                          stroke-linejoin="round" class="feather feather-search">
                          <circle cx="11" cy="11" r="8"></circle>
                          <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                        </svg></button>
                    </div>
                  </div>
                </div>
              </div>
              <div>
              <h6 class="margin">{{StuFullName}}</h6>
            </div>
            
              <!-- Search -->
              <!-- <button (click)="zoom('-')" title="Set to Medium Font" 
              class="text-white border border-white rounded-md px-2 py-2 text-sm">A-</button>
              <button (click)="zoom('A')" title="Set To Small Font"
              class="text-white border border-white rounded-md px-2 py-2 text-sm">A</button>
              <button  (click)="zoom('+')" title="Set To Large Font" 
              class="text-white border border-white rounded-md px-2 py-2 text-sm" >A+</button> -->
              <button (click)="zoom('-')" title="Set to Small Font" 
              class="text-white border border-white rounded-md text-sm A-">A-</button>
              <button (click)="zoom('A')" title="Set To Medium Font"
              class="text-white border border-white rounded-md text-sm A">A</button>
              <button  (click)="zoom('+')" title="Set To Large Font" 
              class="text-white border border-white rounded-md text-sm Fl">A+</button>
              <!-- Theme-Layout -->
              <!-- <div class="dropdown main-header-notification flag-dropdown">
                <a class="nav-link icon country-Flag">
                  <i class="fe fe-sun header-icons header-icons"></i>
                </a>
                <div class="dropdown-menu">
                  <a class="dropdown-item d-flex " (click)="theme('blue')">
                    <div class="d-flex">
                      <span class="mt-2 fas fa-circle blue"> Blue</span>
                    </div>
                  </a>
                  <a class="dropdown-item d-flex" (click)="theme('red')">

                    <div class="d-flex">
                      <span class="mt-2 fas fa-circle red"> Red</span>
                    </div>
                  </a>
                  <a class="dropdown-item d-flex" (click)="theme('white')">

                    <div class="d-flex">
                      <span class="mt-2 fas fa-circle gray"> Gray</span>
                    </div>
                  </a>
                  <a class="dropdown-item d-flex" (click)="theme('green')">

                    <div class="d-flex">
                      <span class="mt-2 fas fa-circle green"> Green</span>
                    </div>
                  </a>
                  <a class="dropdown-item d-flex" (click)="theme('yellow')">

                    <div class="d-flex">
                      <span class="mt-2 fa fa-circle yellow"> Yellow</span>
                    </div>
                  </a>
                  <a class="dropdown-item d-flex" (click)="theme('sky_blue')">

                    <div class="d-flex">
                      <span class="mt-2 fa fa-circle yellow"> Sky Blue</span>
                    </div>
                  </a>

                </div>
              </div> -->
              <!-- Theme-Layout -->
              <!-- country -->
              <!-- <div class="dropdown main-header-notification flag-dropdown">
                <a class="nav-link icon country-Flag">
                  <i class="fa fa-language header-icons header-icons"></i>
                </a>

                <div class="dropdown-menu">
                  <a class="dropdown-item d-flex " (click)="useLanguage('en')">
                    <div class="d-flex">
                      <span class="mt-2 fa-solid fa-circle-a">English</span>
                    </div>
                  </a>
                  <a class="dropdown-item d-flex" (click)="useLanguage('mr')">

                    <div class="d-flex">
                      <span class="mt-2 fa-solid fa-circle-a">Marathi</span>
                    </div>
                  </a>
                </div>
              </div> -->
              <!-- <div class="dropdown main-header-notification flag-dropdown">
                <a class="nav-link icon country-Flag">
                  <i class="fa fa-language header-icons" (click)="useLanguage(defaultlang)"></i>
               </a>
              </div> -->
              <!-- country -->
             
              <!-- Full screen -->
              <div class="dropdown ">
                <a class="nav-link icon full-screen-link">
                  <i class="fe fe-maximize fullscreen-button fullscreen header-icons"></i>
                  <i class="fe fe-minimize fullscreen-button exit-fullscreen header-icons"></i>
                </a>
              </div>
              <!-- Full screen -->
              <!-- Notification -->
              <!-- <div class="dropdown main-header-notification">
                <a class="nav-link icon" href="">
                  <i class="fe fe-bell header-icons"></i>
                  <span class="badge bg-danger nav-link-badge">4</span>
                </a>
                <div class="dropdown-menu">
                  <div class="header-navheading">
                    <p class="main-notification-text">You have 1 unread notification<span
                        class="badge bg-pill bg-primary ms-3">View all</span></p>
                  </div>
                  <div class="main-notification-list">
                    <div class="media new">
                      <div class="main-img-user online"><img alt="avatar" src="./assets/img/5.jpg"></div>
                      <div class="media-body">
                        <p>Congratulate <strong>Olivia James</strong> for New template
                          start</p>
                        <span>Oct 15 12:32pm</span>
                      </div>
                    </div>
                    <div class="media">
                      <div class="main-img-user"><img alt="avatar" src="./assets/img/2.jpg">
                      </div>
                      <div class="media-body">
                        <p><strong>Joshua Gray</strong> New Message Received</p>
                        <span>Oct 13
                          02:56am</span>
                      </div>
                    </div>
                    <div class="media">
                      <div class="main-img-user online"><img alt="avatar" src="./assets/img/3.jpg"></div>
                      <div class="media-body">
                        <p><strong>Elizabeth Lewis</strong> added new schedule realease
                        </p><span>Oct
                          12 10:40pm</span>
                      </div>
                    </div>
                  </div>
                  <div class="dropdown-footer">
                    <a href="javascript:void(0)">View All Notifications</a>
                  </div>
                </div>
              </div> -->
              <!-- Notification -->
              <!-- Messages -->
              <!-- <div class="main-header-notification">
                <a class="nav-link icon" href="#">
                  <i class="fe fe-message-square header-icons"></i>
                  <span class="badge bg-success nav-link-badge">6</span>
                </a>
              </div> -->
              <!-- Messages -->
              <!-- Profile -->
              <!-- (click)="headerClick()" -->
              <div class="dropdown main-profile-menu" (click)="headerClick($event)">
                <a class="d-flex">
                  <span class="main-img-user">
                    <img alt="avatar"  [src]="get() || prfImg || '../../assets/images/user2.jpg'">
                   
                  </span>
                </a>
                <!-- [ngClass]="{'show': isDropdownOpen}" -->
                <div class="dropdown-menu" [ngClass]="{'show': isDropdownOpen}" (click)="$event.stopPropagation()">
                  <div class="header-navheading">
                    <h6 class="main-notification-title">{{userForProfile}}</h6>
                    <p class="main-notification-text">Student</p>
                  </div>
                  <a class="dropdown-item border-top"  (click)="changePassword()">
                    <i class="fa fa-lock"></i> Change Password
                  </a>
                  <a class="dropdown-item" (click)="logout()">
                    <i class="fe fe-power"></i> Sign Out
                  </a>
                </div>
              </div>
              <!-- Profile -->
              <!-- Sidebar -->
              <!-- <div class="dropdown  header-settings">
                <a href="javascript:void(0)" class="nav-link icon" data-bs-toggle="sidebar-right"
                  data-bs-target=".sidebar-right">
                  <i class="fe fe-align-right header-icons"></i>
                </a>
              </div> -->
              <!-- Sidebar -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- End Main Header-->

  <!-- Sidemenu -->
  <div class="sticky">
    <div class="main-menu main-sidebar main-sidebar-sticky side-menu">
      <div class="main-sidebar-header main-container-1 active">
        <div class="sidemenu-logo">
          <a class="main-logo img11" href="#">
            <img src="../../assets/images/logo-light.png" class="header-brand-img desktop-logo" alt="logo">
            <img  src="../../assets/images/logo-light.png" class="hig3 header-brand-img icon-logo" alt="logo">
            <img src="../../assets/images/logo-light.png" class="header-brand-img desktop-logo theme-logo" alt="logo">
            <img  src="../../assets/images/logo-light.png" class="header-brand-img icon-logo theme-logo" alt="logo">
          </a>
        </div>
       
        <div class="main-sidebar-body main-body-1">
          <div class="slide-left disabled" id="slide-left"><i class="fe fe-chevron-left"></i></div>
          <ul class="menu-nav nav">
            <li class="nav-header mt"><span class="nav-label">Registration</span></li>
            <li class="nav-item active show" id="Registration" >
              <a class="nav-link with-sub" (click)="redirect('home')">
                <i class="fa fa-home sidemenu-icon menu-icon "></i>
                <span class="sidemenu-label">Dashboard</span>
                <i class="angle fe fe-chevron-right"></i>
              </a>
              <ul *ngIf="userType == 'new'"  class="nav-sub">
               
                <li *ngIf="OpenAddmission" class="nav-sub-item" (click)="changetheme('Registration')">
                  <a class="nav-sub-link" (click)="redirect('OpenAddmission')" >Registration</a></li>

                  <li *ngIf="regitab" class="nav-sub-item" (click)="changetheme('Registration')">
                    <a class="nav-sub-link" (click)="redirectSubscribe('student-registration-tab')" >Registration</a></li>
              </ul> 
              <ul *ngIf="userType == 'new'" class="nav-sub ">
                <li class="side-menu-label1"></li>
                <li  class="nav-sub-item "  (click)="changetheme('Fees')">
                  <a class="nav-sub-link">Registration Fees</a>
                </li>
              </ul>
              
              <ul *ngIf="userType == 'new'" class="nav-sub">
                <li class="nav-sub-item" (click)="changetheme('Exam-Form')">
                  <a class="nav-sub-link" >Exam Form</a>
                </li>
              </ul>
              <ul *ngIf="userType == 'new'" class="nav-sub ">
                <li class="side-menu-label1"></li>
                <li class="nav-sub-item "  (click)="changetheme('Exam-Fees')">
                  <a class="nav-sub-link">Exam Fees</a>
                </li>
              </ul>
              <ul *ngIf="userType == 'new'" class="nav-sub">
                <li class="nav-sub-item" (click)="changetheme('Admit-Card')">
                  <a class="nav-sub-link">Admit Card</a>
                </li>
              </ul>
              <ul *ngIf="userType == 'new'" class="nav-sub">
                <li  class="nav-sub-item" (click)="changetheme('Marklist')">
                  <a class="nav-sub-link">MarkList</a>
                </li>
              </ul>
              <ul *ngIf="userType == 'new'" class="nav-sub">
                <li  class="nav-sub-item" *ngIf="grievanceUpdate" (click)="changetheme('Complaint')">
                  <a class="nav-sub-link" (click)="redirect('Complaint')">Grievance Form</a>
                </li>
              </ul>
              <ul *ngIf="subjectSelectioMenu && !Failed" class="nav-sub">
                <li *ngIf="userType == 'new'" class="nav-sub-item" (click)="changetheme('Subject-Selection')">
                  <a class="nav-sub-link"  >Subject Selection</a>
                </li>
              </ul>
              <ul class="nav-sub">
                <li  class="nav-sub-item" (click)="changetheme('provisional')">
                  <a class="nav-sub-link" (click)="redirect('provisional')">Student Request</a>
                </li>
              </ul>
               <ul class="nav-sub" *ngIf="userType == 'new'">
                <li  class="nav-sub-item" (click)="changetheme('practical-time-table')">
                  <a class="nav-sub-link" (click)="redirect('practical-time-table')">Practical Time Table</a>
                </li>
              </ul>
            </li>
          </ul>
          <!-- <ul class="menu-nav nav">
            <li class="nav-header mt"><span class="nav-label">Registration</span></li>
            <li class="nav-item" id="Registration"  (click)="changetheme('Registration')">
              <a class="nav-link with-sub" (click)="redirect('home')" >
                <i class="fa fa-cogs sidemenu-icon menu-icon "></i>
                <span class="sidemenu-label">Dashboard</span>
                <i class="angle fe fe-chevron-right"></i>
              </a>
              <ul class="nav-sub minmaxadmin ">
                <li class="side-menu-label1"></li>
                <li class="nav-sub-item" ><a  class="nav-sub-link"  
                    (click)="redirect('student-registration-tab'); colorchnage(student-registration-tab)">Registration</a></li>
              </ul>
              <ul class="nav-sub minmaxadmin ">
                <li class="side-menu-label1"></li>
                <li class="nav-sub-item" ><a  class="nav-sub-link" 
                    (click)="redirect('Fees'); colorchnage(Fees)">Fees</a></li>
              </ul>
              <ul class="nav-sub minmaxadmin ">
                <li class="side-menu-label1"></li>
                <li class="nav-sub-item" ><a  class="nav-sub-link" 
                    (click)="redirect('Exam-Form'); colorchnage(Exam-Form)">Exam Form</a></li>
              </ul>
            </li>
          </ul> -->
          
          <div class="slide-right" id="slide-right"><i class="fe fe-chevron-right"></i></div>
        </div>
      </div>
    </div>
  </div>
  <!-- End Sidemenu -->
  <!-- Main Content-->
  <router-outlet *ngIf="aaa"></router-outlet>
  
  <!-- End Main Content-->

  <!-- Main Footer-->
  <!-- <div class="main-footer text-center">
    <div class="container">
      <div class="row row-sm">
        <div class="col-md-12">
          <span>Copyright © 2022 <a>SMB Group of Company</a> All rights reserved.</span>
        </div>
      </div>
    </div>
  </div> -->
  <!--End Footer-->
</div>